import { render } from "./LastPageLink.vue?vue&type=template&id=1ec3a9cf"
import script from "./LastPageLink.vue?vue&type=script&lang=js"
export * from "./LastPageLink.vue?vue&type=script&lang=js"
script.render = render

export default script